import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { ProductBundleItemModel, ProductBundleModel, ProductBundleType, ProductPricesModel } from '@libs/shop/models';
import { ProductPriceVisibilityService } from '@libs/shared/ui';
import { ProductPriceFormatterComponent } from '../../catalog/product-prices/product-price-formatter';

@Component({
  selector: 'ui-product-detail-bundle-prices',
  imports: [
    NgTemplateOutlet,
    ProductPriceFormatterComponent,
  ],
  templateUrl: './product-detail-bundle-prices.component.html',
  styleUrl: './product-detail-bundle-prices.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailBundlePricesComponent {
  public priceVisibilityService: ProductPriceVisibilityService = inject(ProductPriceVisibilityService);
  public bundleType: InputSignal<ProductBundleType> = input.required();
  public bundle: InputSignal<ProductBundleModel> = input.required();
  public bundlePrices: InputSignal<ProductPricesModel | undefined> = input();
  public arePricesVisible: Signal<boolean> = computed(() => this.priceVisibilityService.arePricesVisible(this.bundlePrices()));

  public freeProducts: Signal<ProductBundleItemModel[]> = computed(() => {
    return this.bundle().products.filter(x => x.isFree);
  });

  public paidProducts: Signal<ProductBundleItemModel[]> = computed(() => {
    return this.bundle().products.filter(x => !x.isFree);
  });

  public sumRetailUnitDeposit: Signal<number> = computed(() => {
    return this.bundle().products
      .filter(x => !!x.prices?.salesUnitDeposit)
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      .map(x => x.prices!.salesUnitDeposit! * x.quantity)
      .reduce((a, b) => a + b, 0);
  });
}
